<template>
    <button class="button-fill" type="submit" :disabled="loading">
        <span><slot>{{ label}}</slot></span>
        <Spinner v-if="loading" />
        <ArrowRightIcon v-else />
    </button>
</template>

<script setup>
import ArrowRightIcon from '../../../images/icons/arrow-right.svg';
import Spinner from '../Ui/Spinner.vue';

defineProps({
    loading: { type: Boolean, default: false },
    label: { type: String, default: 'Submit' },
})
</script>
